import type { FgaAssignableRelation, FgaObjectType } from './generated/model'

/** The TPRM areas a role holds one organisation-wide level in, under the role editor's TPRM section. */
export const TPRM_AREAS = ['risks', 'alerts', 'subprocessors'] as const

export type TprmArea = (typeof TPRM_AREAS)[number]

/** The areas a role holds one organisation-wide level in, set from the role editor. */
export const ORG_WIDE_ACCESS_AREAS = ['documents', ...TPRM_AREAS] as const

export type OrgWideAccessArea = (typeof ORG_WIDE_ACCESS_AREAS)[number]

// A new area does not compile until it is added here too.
export const byOrgWideAccessArea = <V>(value: (area: OrgWideAccessArea) => V): Record<OrgWideAccessArea, V> => ({
  documents: value('documents'),
  risks: value('risks'),
  alerts: value('alerts'),
  subprocessors: value('subprocessors'),
})

/**
 * Each area's grant hangs off its own organisation relation, so a level in one area never reaches another. Areas that
 * share a grant type tell their objects apart by the id suffix.
 */
export const ORG_WIDE_ACCESS_GRANTS = {
  documents: { grantType: 'document_grant', organisationRelation: 'document_grant', idSuffix: '' },
  risks: { grantType: 'tprm_grant', organisationRelation: 'risk_grant', idSuffix: '/risks' },
  alerts: { grantType: 'tprm_grant', organisationRelation: 'alert_grant', idSuffix: '/alerts' },
  subprocessors: { grantType: 'tprm_grant', organisationRelation: 'subprocessor_grant', idSuffix: '/subprocessors' },
} as const satisfies Record<
  OrgWideAccessArea,
  { grantType: FgaObjectType; organisationRelation: FgaAssignableRelation<'organisation'>; idSuffix: string }
>
